//import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
//import { COLORS } from '../../../constants/colors';
import { CANDIDATE } from '../../../constants/props';
import IntroduceForm from '../../../components/forms/introduce';
import { updateCandidate } from '../../../api/candidate';
import { useParams } from 'react-router-dom';
import useNotifications from '../../../hooks/useNotification';
import { fetchAvailabilities } from '../../../api/availability';
import useFetch from '../../../hooks/useFetch';


const Edit = ({
  firstName: initialFirstName,
  lastName: initialLastName,
  role: initialRole,
  city: initialCity,
  country: initialCountry,
  availability: initialAvailability,
  github: initialGithub,
  online: initialOnline,
  video: initialVideo,
  updatedAt: initialUpdatedAt,
  reloadCandidateUpdatedAtData
}) => {
//  const classes = useStyles();
  const { hash } = useParams();
  const notification = useNotifications();
  const { result: availabilities } = useFetch(fetchAvailabilities, null, []);
  const [lastValues, setLastValues] = useState({
    firstName: initialFirstName,
    lastName: initialLastName,
    role: initialRole,
    city: initialCity,
    country: initialCountry,
    github: initialGithub,
    online: initialOnline,
    video: initialVideo
  })

  const handleEdit = (data) => {


    if (
      lastValues.firstName === data.firstName &&
      lastValues.lastName === data.lastName &&
      lastValues.role.hash === data.role &&
      lastValues.city === data.city &&
      lastValues.country === data.country &&
      lastValues.availability === data.availability &&
      lastValues.github === data.github &&
      lastValues.online === data.online &&
      lastValues.video === data.video
    ) return

    updateCandidate(hash, {
      withCredentials: true,
      immediately: true,
      ...data
    })
    .then((res) => {
      if (res.success) {
        notification.success({
          message: "Candidate's introduce was successfully updated",
        });
        setLastValues({
          firstName: data.firstName,
          lastName: data.lastName,
          role: {
            hash: data.role,
          },
          city: data.city,
          country: data.country,
          availability: data.availability,
          github: data.github,
          online: data.online,
          video: data.video
        })
        reloadCandidateUpdatedAtData()
      } else {
        
        if(res?.error?.errors && typeof res.error.errors === 'object' && Object.values(res.error.errors).length > 0) {
          const message = Object.values(res.error.errors).map((error) => error).join(' , ')
          notification.error({message})
        }else{
          notification.error(res.error)
        }
        
      }
    })
  }

  useEffect(() => {
    if(availabilities){
      const currentAvailability = availabilities.find((data)=>
        data.description === initialAvailability.description
      )
      setLastValues({
        ...lastValues,
        availability: currentAvailability.hash
      })

    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availabilities])

  if(!availabilities) return <></>
  
  return (
    <IntroduceForm
      {...{
        firstName: initialFirstName,
        lastName: initialLastName,
        role: initialRole,
        city: initialCity,
        country: initialCountry,
        availability: initialAvailability,
        github: initialGithub,
        online: initialOnline,
        video: initialVideo,
        updatedAt: initialUpdatedAt,
      }}
      onSubmit={(data) => handleEdit(data)}
    />
  );
};

Edit.propTypes = {
  CANDIDATE,
};

export default Edit;
